<div class="message" [class.message--user]="message.role === 'user'" [class.message--assistant]="message.role === 'assistant'">

  <div *ngIf="message.role === 'assistant'" class="message__avatar" aria-hidden="true">
    <mat-icon class="material-icons-outlined">auto_awesome</mat-icon>
  </div>

  <div class="message__body">
    <!-- User -->
    <div *ngIf="message.role === 'user'" class="bubble bubble--user">{{ message.text }}</div>

    <!-- Assistant -->
    <ng-container *ngIf="message.role === 'assistant'">
      <div *ngIf="message.status === 'streaming' && !message.text" class="typing"
           [attr.aria-label]="'ChatBot-Thinking' | translate: {Default: 'Thinking'}">
        <span></span><span></span><span></span>
      </div>

      <div *ngIf="message.text" class="bubble bubble--assistant"
           [class.bubble--streaming]="message.status === 'streaming'"
           [innerHTML]="message.text | chatMarkdown"></div>

      <div *ngIf="message.status === 'error'" class="notice notice--error" role="alert">
        <mat-icon class="material-icons-outlined">error_outline</mat-icon>
        <span>{{ 'ChatBot-ErrorReply' | translate: {Default: "Sorry, I couldn't finish that reply. Please try again."} }}</span>
      </div>

      <div *ngIf="message.citations.length" class="citations">
        <span class="citations__label">{{ 'ChatBot-Sources' | translate: {Default: 'Sources'} }}</span>
        <span *ngFor="let c of message.citations" class="citation" [title]="c">
          <mat-icon class="material-icons-outlined">description</mat-icon>
          <span class="citation__text">{{ c }}</span>
        </span>
      </div>

      <div *ngFor="let action of message.actions; trackBy: trackAction"
           class="action-card" [ngClass]="'action-card--' + action.state">
        <div class="action-card__head">
          <mat-icon class="material-icons-outlined">bolt</mat-icon>
          <span>{{ 'ChatBot-ProposedAction' | translate: {Default: 'Proposed action'} }}</span>
        </div>
        <p class="action-card__summary">{{ action.summary }}</p>

        <div class="action-card__footer" [ngSwitch]="action.state">
          <ng-container *ngSwitchCase="'pending'">
            <button type="button" class="btn btn--primary" (click)="confirm(action)">
              {{ 'ChatBot-Confirm' | translate: {Default: 'Confirm'} }}
            </button>
            <button type="button" class="btn btn--ghost" (click)="dismiss(action)">
              {{ 'ChatBot-Dismiss' | translate: {Default: 'Dismiss'} }}
            </button>
          </ng-container>
          <span *ngSwitchCase="'confirming'" class="status">
            <mat-spinner diameter="16"></mat-spinner>
            {{ 'ChatBot-Working' | translate: {Default: 'Working on it…'} }}
          </span>
          <span *ngSwitchCase="'confirmed'" class="status status--success">
            <mat-icon class="material-icons-outlined">check_circle</mat-icon>
            {{ 'ChatBot-Done' | translate: {Default: 'Done'} }}
          </span>
          <span *ngSwitchCase="'dismissed'" class="status status--muted">
            <mat-icon class="material-icons-outlined">block</mat-icon>
            {{ 'ChatBot-Dismissed' | translate: {Default: 'Dismissed'} }}
          </span>
          <ng-container *ngSwitchCase="'failed'">
            <span class="status status--error">
              <mat-icon class="material-icons-outlined">error_outline</mat-icon>
              {{ 'ChatBot-ActionFailed' | translate: {Default: "Couldn't complete this action"} }}
            </span>
            <button type="button" class="btn btn--ghost" (click)="confirm(action)">
              {{ 'ChatBot-Retry' | translate: {Default: 'Retry'} }}
            </button>
          </ng-container>
        </div>
      </div>

      <div *ngIf="message.status === 'done' && message.text" class="toolbar">
        <button type="button" class="icon-btn" (click)="copy()"
                [matTooltip]="(copied ? 'ChatBot-Copied' : 'ChatBot-Copy') | translate: {Default: copied ? 'Copied' : 'Copy'}"
                [attr.aria-label]="'ChatBot-Copy' | translate: {Default: 'Copy'}">
          <mat-icon class="material-icons-outlined">{{ copied ? 'check' : 'content_copy' }}</mat-icon>
        </button>
        <ng-container *ngIf="message.messageId">
          <button type="button" class="icon-btn" [class.icon-btn--active]="message.rating === 'up'"
                  [disabled]="!!message.rating" (click)="session.rate(message, true)"
                  [matTooltip]="'ChatBot-GoodResponse' | translate: {Default: 'Good response'}"
                  [attr.aria-label]="'ChatBot-GoodResponse' | translate: {Default: 'Good response'}">
            <mat-icon class="material-icons-outlined">thumb_up</mat-icon>
          </button>
          <button type="button" class="icon-btn" [class.icon-btn--active]="message.rating === 'down'"
                  [disabled]="!!message.rating" (click)="session.rate(message, false)"
                  [matTooltip]="'ChatBot-BadResponse' | translate: {Default: 'Bad response'}"
                  [attr.aria-label]="'ChatBot-BadResponse' | translate: {Default: 'Bad response'}">
            <mat-icon class="material-icons-outlined">thumb_down</mat-icon>
          </button>
          <span *ngIf="message.rating" class="toolbar__thanks">
            {{ 'ChatBot-ThanksFeedback' | translate: {Default: 'Thanks for the feedback'} }}
          </span>
        </ng-container>
      </div>
    </ng-container>
  </div>
</div>
